import React from 'react';
import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';

import App from './App';
import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// Seems like react-tooltip doesn't work with React V18

// const container = document.getElementById('root');
// const root = createRoot(container);
// root.render(<React.StrictMode> <App /> </React.StrictMode>);